type Primitive = number | string | symbol | undefined

export function getSnippetArgs(
  ...args: (Primitive | Record<string, Primitive>)[]
): string {
  const result = args.map((arg) => getSnippetValue(arg))

  // Remove unused arguments from the end of the array
  while (result.length > 0 && !result[result.length - 1]) {
    result.pop()
  }

  // If there are 2 or less arguments, return them in a single line
  if (result.length <= 2) {
    return result.join(", ")
  }

  // Otherwise, indent the arguments
  return `\n${indentString(result.join(",\n"))}\n`
}

function getSnippetValue(
  value: Primitive | Record<string, Primitive>,
): string | undefined {
  if (!value) {
    return undefined
  }

  switch (typeof value) {
    case "number":
      return value.toString()

    case "string":
      return `"${value}"`

    case "symbol":
      // Symbols are used to represent variables ("raw code") in the request snippet
      return value.description ?? String(value)

    case "object":
      return getSnippetObject(value)

    default:
      throw new Error(`Unknown value type: ${typeof value}`)
  }
}

const getSnippetObject = (
  object: Record<string, Primitive>,
): string | undefined => {
  const result = Object.entries(object)
    .map(([key, value]) => [key, getSnippetValue(value)])
    .filter(([_, value]) => Boolean(value))
    .map(([key, value]) => `${key as string}: ${value as string}`)

  if (result.length === 0) {
    return undefined
  }

  return `{\n${indentString(result.join(",\n"))}\n}`
}

const indent = "  "

function indentString(string: string): string {
  return `${indent}${string.replace(/\n/g, `\n${indent}`)}`
}
